export default () => ({
    toasts: [],
    duration: 5000,

    addToast({message, description, icon, link, linkText, persistent = false}) {
      const uuid = Math.random().toString(36).substr(2, 9);
      let timeoutId = null;

      if (!persistent) {
        timeoutId = setTimeout(() => {
          this.removeToastByUuid(uuid);
        }, this.duration);
      }
      
      this.toasts.push({
        uuid,
        message,
        description,
        icon: icon,
        link: link,
        linkText: linkText,
        show: true,
        timeoutId,
        persistent
      });
    },
  
    removeToastByUuid(uuid) {
      const index = this.toasts.findIndex(t => t.uuid === uuid);
      if (index === -1) return;
      this.removeToast(index);
    },
  
    removeToast(index) {
      clearTimeout(this.toasts[index].timeoutId);
      this.toasts[index].show = false;
    },

    // Dismissing a toast only clears its `show` flag, so the entry stays in
    // `toasts` for the rest of the page's life. A caller asking "is this
    // message already on screen?" has to read `show`, or a message shown once
    // is suppressed forever after the user closes it.
    hasVisibleToast(message) {
      return this.toasts.some(t => t.show && t.message === message);
    },

    // What the live region announces: the newest toast still on screen, its two
    // sentences joined, and nothing when the last one has been dismissed. Reading
    // the last ARRAY entry instead would leave a dismissed toast's text in the
    // region, and a repeat of that same message would then change nothing for a
    // screen reader to announce.
    liveRegionText() {
      const visible = this.toasts.filter(t => t.show);
      const latest = visible[visible.length - 1];

      return latest ? [latest.message, latest.description].filter(Boolean).join(' ') : '';
    },
  
    pauseToast(index) {
      if(!this.toasts[index]) return;
      clearTimeout(this.toasts[index].timeoutId);
    },
  
    resumeToast(index) {
      if(!this.toasts[index]) return;
      if(this.toasts[index].persistent) return;
      const uuid = this.toasts[index].uuid;
      this.toasts[index].timeoutId = setTimeout(() => {
        this.removeToastByUuid(uuid);
      }, this.duration);
    }
  });
  